import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const index = (props) => {
  return (
    <div className="dark:bg-primary-darkBg bg-[#f5f7f9]">
      <Navbar />
      <div className="min-h-[calc(100vh-56px)]">{props?.children}</div>
      <Footer />
    </div>
  );
};

export default index;
